const colorTheme = {
  // headline
  blue_headline: '#C6E9EF',
  // primary
  primary_active: '#FF8890',
  primary_hover: '#F5767F',
  primary_inactive: '#FFC3C7',
  primary_button: '#FFE5E7',
  primary_bg: '#FFF1F6',

  // Neutral color
  line_3: '#86909C',
  line_2: '#C9CDD4',
  line_1: '#DDDDDD',
  print_line: 'black',

  fill_5: '#E5E6EB',
  fill_4: '#1D2129',
  fill_3: '#E5E5E5',
  // fill_3: '#ADADAD',
  fill_2: '#F6F7FC',
  fill_1: '#FFFFFF',

  text_5: '#2D6772',
  text_4: '#32a7e5',
  text_4_v2: '#505050',
  text_3: '#1D2129',
  text_3_v2: '#64748B',
  text_2: '#767676',
  text_1: '#FFFFFF',

  // Functional color
  info_orange: '#FF7D00',
  info_bg_orange: '#F8D9BB',
  info_3: '#6FABB6',
  info_bg_3: '#C6E9EF',
  info_2: '#FFDC7C',
  info_bg_2: '#FEEDBF',
  info_1: '#777D7C',
  hover_info: '#FDCC43',
  welcome: '#5C4441',
  yellow_headline: '#FEEDBF',
  info_4: 'blue',
  

  error_6: '#F53F3F',
  error_5: '#F76560',
  error_4: '#CB2634',
  error_3: '#FBACA3',
  error_2: '#FDCDC5',
  error_1: '#FFECE8',

  black: '#000',

  //v2
  v2_primary_bg_6: '#D2464F',
  v2_primary_bg_5: '#F5767F',
  v2_primary_bg_4: '#FF8890',
  v2_primary_bg_3: '#FFC3C7',
  v2_primary_bg_2: '#FFE5E7',
  v2_primary_bg_1: '#FFF1F6',
  v2_primary_bg_7: '#FFF6F9', 
  
  v2_secondary_6: '#F2FEFF',
  v2_secondary_5: '#E4F4F6',
  v2_secondary_4: '#A8DEE8',
  v2_secondary_3: '#2D6772',
  v2_secondary_2: '#6FABB6',
  v2_secondary_1: '#C6E9EF',

  v2_neutral_8: '#E1E1E5', 
  v2_neutral_7: '#777D7C', 
  v2_neutral_6: '#232F3E',
  v2_neutral_5: '#ADADAD',
  v2_neutral_4: '#E5E6EB',
  v2_neutral_3: '#F5F5F5',
  v2_neutral_2: '#F6F7FC',
  v2_neutral_1: '#FFFFFF',
  v2_neutral_0: '#FCFCFD',


  v2_text_5: '#1D2129',
  v2_text_4: '#505050',
  v2_text_3: '#64748B',
  v2_text_2: '#CBD5E1',
  v2_text_1: '#FFFFFF',

  v2_border_3: '#86909C',
  v2_border_2: '#CCD4DC',
  v2_border_1: '#E9EDF2',

  v2_yellow_9: '#ffff00',
  v2_yellow_7: '#A95A23',
  v2_yellow_6: '#EBA33B',
  v2_yellow_5: '#F4C04B',
  v2_yellow_4: '#F6D465',
  v2_yellow_3: '#FBE696',
  v2_yellow_2: '#FDF4CE',
  v2_yellow_1: '#FFFDED',

  v2_orange_6: '#B67650',
  v2_orange_5: '#C84B31',
  v2_orange_3: '#DC5500',
  v2_orange_2: '#FF7D00',
  v2_orange_1: '#FFFAF8',

  v2_blue_6: '#3AADD9',
  v2_blue_5: '#66D4F1',
  v2_blue_4: '#4B63C7',
  v2_blue_3: '#4384FF',
  v2_blue_2: '#D7EDFF',
  v2_blue_1: '#EEF4FF',

  v2_green_9: '#808836',
  v2_green_8: '#346751',
  v2_green_7: '#0C865D',
  v2_green_6: '#0DA472',
  v2_green_5: '#35D39E',
  v2_green_4: '#6FE7BF',
  v2_green_3: '#A5F3D9',
  v2_green_2: '#D1F9EB',
  v2_green_1: '#F7FFFD',
  v2_green_10: '#B4DF80',
  v2_green_11: '#89C053',

  v2_purple_6: '#9579DA',
  v2_purple_5: '#B3A4EE',
  v2_purple_4: '#4F1787',
  v2_purple_3: '#9747FF',
  v2_purple_2: '#DAD4FF',
  v2_purple_1: '#F1EFFF',

  v2_other_5: '#D56FAC',
  v2_other_4: '#F199CE',
  v2_other_3: '#DA072D',
  v2_other_2: '#C52884',
  v2_other_1: '#FFEAF6',
};

export default colorTheme;
